import { getDestinationCountryResorts, getDestinationResortIds, type Selection } from '@/entities/searchCriteria';
import type { Resort } from '@/shared/model';
import type { ResortsFilterGroupId, SerpFilterOption } from '../model/types';

export const RESORTS_FILTER_GROUP_ID: ResortsFilterGroupId = 'resorts';

export const RESORTS_FILTER_INLINE_LIMIT = 5;

const RESORT_NAME_COLLATOR = new Intl.Collator('ru', { sensitivity: 'base' });

function compareResorts(first: Resort, second: Resort): number {
  const popularDiff = Number(second.isPopular) - Number(first.isPopular);

  if (popularDiff !== 0) return popularDiff;

  return RESORT_NAME_COLLATOR.compare(first.name, second.name);
}

export function getResortsFilterResorts(destination: Selection | null): Resort[] {
  const selectedIds = new Set(getDestinationResortIds(destination));

  return getDestinationCountryResorts(destination)
    .filter((resort) => resort.atFiltering || selectedIds.has(resort.id))
    .sort((first, second) => compareResorts(first, second));
}

export function toResortFilterOption(resort: Resort): SerpFilterOption {
  return { key: String(resort.id), label: resort.name };
}

export function getResortsFilterOptions(destination: Selection | null): SerpFilterOption[] {
  return getResortsFilterResorts(destination).map((resort) => toResortFilterOption(resort));
}
